<template>
    <transition-group name="list-item">
        <slot></slot>
    </transition-group>
</template>

<style lang="scss">

    .list-item-enter-active,
    .list-item-leave-active
    {
        transition: all 300ms ease;
    }

    .list-item-leave-from,
    .list-item-enter-to
    {
        position: absolute;
        transform: scale( 1 );
        opacity: 1;
    }

    .list-item-enter-from,
    .list-item-leave-to
    {
        position: absolute;
        opacity: 0;
    }

</style>